(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // This event will be fired for each subscription widget that gets created
  document.addEventListener('sealsubs:subscription_widget_created', function (e) {
    // Subscription widget was created
    // Do your magic :)
     
     const sourceElementTemplate = document.getElementById('seal-custom-benefits-tpl');

    const destinationElement = document.querySelector('.sls-selling-plan-description-content');
     const sourceElementTemplateClone = sourceElementTemplate.content.cloneNode(true);
     //const hasChildDiv = destinationElement.querySelector('div.seal-custom-benefits') !== null;

    if (sourceElementTemplateClone && destinationElement) {
      destinationElement.after(sourceElementTemplateClone);
    } else {
      console.error('Source or destination element not found!');
    }
  });

  // This event will be fired whenever a different selling plan is selected
  document.addEventListener('sealsubs:selling_plan_changed', function (e) {
   /*
    // e.detail will contain the following JSON object:
    // {
    // 		selling_plan_id	: sellingPlanId,				// Represents the ID of the selected selling plan
    // 		element			: subscriptionWidgetElement		// Contains an HTML element of the widget where this change happened
    // }

   
    */
   console.log(e.detail);
   const sealCustomBenefitsElement = document.querySelector('.seal-custom-benefits');
     sealCustomBenefitsElement.style.display = "none";
   if(e.detail.selling_plan_id) {

      if (sealCustomBenefitsElement.style.display === "none") {
        sealCustomBenefitsElement.style.display = "block"; // or another display value like 'inline-block', 'flex', 'grid'
    } else {
        sealCustomBenefitsElement.style.display = "none";
    }

   }


  });
  } catch(e) { console.error(e); }
})();

})();
